/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Emailsentdescription2Inputs */

const en_emailsentdescription2 = /** @type {(inputs: Emailsentdescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A new confirmation email has been sent to ${i?.email}`)
};

const de_emailsentdescription2 = /** @type {(inputs: Emailsentdescription2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eine neue Bestätigungs-E-Mail wurde an ${i?.email} gesendet`)
};

/**
* | output |
* | --- |
* | "A new confirmation email has been sent to {email}" |
*
* @param {Emailsentdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const emailsentdescription2 = /** @type {((inputs: Emailsentdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Emailsentdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_emailsentdescription2(inputs)
	return de_emailsentdescription2(inputs)
});
export { emailsentdescription2 as "emailSentDescription" }